import AddButton from "components/buttons/addbutton";
import ListButtons from "components/buttons/listButtons";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  query,
  collection,
  orderBy,
  getDocs,
  or,
  and,
  where,
  deleteDoc,
  doc,
  endBefore,
  limit,
  limitToLast,
  startAfter,
  Timestamp,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const VisaList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [visaData, setVisaData] = useState([]); // we fetch the data from the backend and shown in the form of list
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  //these are pagination variables
  const [page, setPage] = useState(0);
  const [filteredDates, setFilteredDates] = useState(null);
  const [isNext, setIsNext] = useState(false);

  // MARK: use Effect function
  useEffect(() => {
    fetchVisaApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.visaLayoutHeading;
  }, []);

  // MARK:  function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  // MARK: fetch student's performance API
  async function fetchVisaApi() {
    let q = query(
      collection(dbFirestore, TableName.visa),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );

    const querySnapshot = await getDocs(q);
    setVisaData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // MARK: Edit data function
  const tapOnEdit = (visaData) => () => {
    navigate(RoutingPaths.editVisa, {
      state: visaData,
    });
  };

  // MARK: Delete data function
  const tapOnDeleteConfirm = (visa) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this student data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteVisaInfoApi(visa);
      }
    });
  };

  // MARK: delete API
  const deleteVisaInfoApi = async (visa) => {
    await deleteDoc(doc(dbFirestore, TableName.visa, visa.id));
    setVisaData((prevState) => prevState.filter((el) => el.id !== visa.id));
    toast.success(ToastMessages.visaDeleted);
  };

  // MARK: serach api
  const searchVisaApi = async (e) => {
    const searchText = e.target.value.toLowerCase();
    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.visa),
        or(
          and(
            where("applicant_name", ">=", searchText),
            where("applicant_name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "applicant_name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "applicant_name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "applicant_name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "applicant_name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      setVisaData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchVisaApi();
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    setPage(page + 1);

    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.visa),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );

      const querySnapshot = await getDocs(paginationQuery);

      setVisaData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (visaData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  // MARK: previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.visa),
      orderBy("created_at", "desc"),
      endBefore(visaData[0].created_at),
      limitToLast(Constant.perPage)
    );

    const querySnapshot = await getDocs(paginationQuery);

    setVisaData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // MARK: condition while selecting the previous button
  const showPrevious = () => {
    if (visaData.length === 0) {
      fetchVisaApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK:  reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchVisaApi();
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.visa),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc"), limit(Constant.perPage)
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.visa),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  // MARK: filter function using in input
  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
    setVisaData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <div style={{ flexGrow: "1" }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchVisaApi}
                placeholder="Search by name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  // MARK:students performance columns data
  const visaColumns = [
    {
      field: "applicant_name",
      header: "Student Name",
      className: "table__column__capital",
    },
    {
      field: "visa_Processing_time",
      header: "Processing Time",
      className: "table__column__capital",
    },
    {
      field: "visa_type",
      header: "Visa Type",
      className: "table__column__capital",
    },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <ListButtons
            editclick={tapOnEdit(data)}
            deleteclick={tapOnDeleteConfirm(data)}
          />
          <ToastContainer />
        </>
      ),
    },
  ];

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.visa),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.visa),
        orderBy("created_at", "desc"),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  // MARK: modify visa model in which we add new inputs in an array
  const modifyVisaModel = (visaModal) => {
    visaModal.created_at = moment(visaModal.created_at).format(
      Dateformat.YYYYMMDD
    );
    return visaModal;
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) => modifyVisaModel(model));

        const filterUserData = mylist.map(
          ({
            visa_Processing_time,
            applicant_name,
            visa_type,
            created_at,
          }) => ({
            applicant_name: applicant_name,
            visa_Processing_time: visa_Processing_time,
            visa_type: visa_type,
            created_at: created_at,
          })
        );

        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "visa");
          XLSX.writeFile(workBook, "visa_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate)
        }
      }
    });
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.visaLayoutHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addVisa} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={visaData}
            header={header}
            emptyMessage="No data found."
          >
            {visaColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({
                    item: visaData[visaData.length - 1],
                  })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default VisaList;
